import { ActionButton, DefaultButton, Dialog, DialogFooter, DialogType, MessageBarType, PrimaryButton, Stack } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEventSchedule } from '../../../../../Models/Event/IEventSchedule';
import { ISchedulesTeacherList } from '../../../../../Models/Event/ISchedulesTeacherList';
import { AddTeachersToLesson } from '../AddTeachersToLesson/AddTeachersToLesson';
import { TeachersListView } from './TeachersListView';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventSchedulesApi } from '../../../../../Services/API/EventSchedules/IEventSchedulesApi';
import * as Services from '../../../../../Services/Services';
import { IAppStore } from '../../../../../Stores/IAppStore';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';

interface ITeachersListProps {
    eventSchedule?: IEventSchedule;
    refresh: () => void;
    profile: IUserProfile;
}

export const getCanEdit = (lessonDate: Date, isAdmin: boolean) => {
    const monthLesson = lessonDate.getMonth();
    const currentMonth = new Date(Date.now()).getMonth();
    const currentDay = new Date(Date.now()).getDate();
    if (monthLesson != currentMonth && currentDay > 5 && isAdmin === false) {
        return false;
    }
    else {
        return true;
    }
}


export const TeachersList: React.FunctionComponent<ITeachersListProps> = (props) => {
    const [selectedTeacher, setSelectedTeacher] = React.useState<ISchedulesTeacherList>();
    const [isAddDialogOpened, setIsAddDialogOpened] = useBoolean(false)
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [isDeleteTeacherOpened, setIsDeleteTeacherOpened] = useBoolean(false)
    const [teacherToDelete, setTeacherToDelete] = React.useState<ISchedulesTeacherList>()
    const [canEdit, setCanEdit] = React.useState(false);


    const deleteTeacherDialog = async (item: ISchedulesTeacherList) => {
        setTeacherToDelete(item);
        setIsDeleteTeacherOpened.setTrue();
    }

    const deleteTeacher = async () => {
        if (props.eventSchedule && teacherToDelete) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const schedulesApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
            const result = await schedulesApi.removeTeacherFromLesson(props.eventSchedule?.eventId, props.eventSchedule?.id, teacherToDelete.id);
            if (result.isSuccess && result.data) {
                setTeacherToDelete(undefined);
                setIsDeleteTeacherOpened.setFalse();
                props.refresh();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }

   

    React.useEffect(() => {
        if (props.eventSchedule) {
            setCanEdit(getCanEdit(props.eventSchedule.date, props.profile.isAdmin))
        }
        else {
            setCanEdit(false);
        }


    }, [props.eventSchedule])
   

    
    return (<Stack>
        <ActionButton disabled={!canEdit} onClick={setIsAddDialogOpened.setTrue} iconProps={{ iconName: "Add" }}>Přidat lektora</ActionButton>

        <TeachersListView canEdit={canEdit} eventSchedule={props.eventSchedule} items={props.eventSchedule?.teachers ? props.eventSchedule?.teachers : []}
            selectTeacher={setSelectedTeacher}
            deleteTeacher={deleteTeacherDialog}        />

        {isAddDialogOpened ? <AddTeachersToLesson eventId={props.eventSchedule?.eventId ? props.eventSchedule?.eventId : 0}
            lessonId={props.eventSchedule?.id ? props.eventSchedule?.id : 0}
            refresh={props.refresh}
            isOpened={isAddDialogOpened}
            onDismiss={setIsAddDialogOpened.setFalse}/>
            : null}

        {isDeleteTeacherOpened ?
            <Dialog
                hidden={!isDeleteTeacherOpened}
                onDismiss={setIsDeleteTeacherOpened.setFalse}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Odstranění docházky",
                    subText: "Opravdu ostranit vybranou lekci"
                }}
                modalProps={{ isBlocking: true }}>
                <DialogFooter>
                    <PrimaryButton onClick={deleteTeacher} text="Odstranit" />
                    <DefaultButton onClick={setIsDeleteTeacherOpened.setFalse} text="Zavřít" />
                </DialogFooter>
            </Dialog> : null}

    </Stack>) 
}


const TeachersListToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,

});

const TeachersListDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(TeachersListToProps, TeachersListDispatchToProps)(TeachersList);
